import { z } from "zod";

export const BindingEnum = z.enum(["static", "tenant", "project", "account"]);

export const BindingSchema = z.object({
  type: BindingEnum,
  id: z.string().optional(),
});
export type BindingResponse = z.infer<typeof BindingSchema>;

export type Binding = z.infer<typeof BindingEnum>;
export type ScopedBinding = Binding;
